var _rect, _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    fill: "#E2E6EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6666 36.9998C28.6666 34.6066 30.6067 32.6665 33 32.6665H67C69.3932 32.6665 71.3333 34.6066 71.3333 36.9998V63.6665C71.3333 66.0597 69.3932 67.9998 67 67.9998H33C30.6067 67.9998 28.6666 66.0597 28.6666 63.6665V36.9998ZM33 34.6665C31.7113 34.6665 30.6666 35.7112 30.6666 36.9998V63.6665C30.6666 64.9552 31.7113 65.9998 33 65.9998H67C68.2886 65.9998 69.3333 64.9552 69.3333 63.6665V36.9998C69.3333 35.7112 68.2886 34.6665 67 34.6665H33Z",
    fill: "#B2B9C4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.6666,
    cy: 41.9998,
    rx: 4.33333,
    ry: 4.33333,
    fill: "#B2B9C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 60.333V58.3567C34.3333 57.9147 34.5088 57.4907 34.8214 57.1782L40.2095 51.7901C40.8386 51.161 41.8509 51.1369 42.5092 51.7353L43.8405 52.9456C44.4921 53.538 45.492 53.5212 46.1234 52.9074L55.8216 43.4786C56.4751 42.8433 57.5175 42.8506 58.1619 43.495L65.8451 51.1782C66.1577 51.4907 66.3333 51.9147 66.3333 52.3567V60.333C66.3333 61.2535 65.5871 61.9997 64.6666 61.9997H35.9999C35.0794 61.9997 34.3333 61.2535 34.3333 60.333Z",
    fill: "#B2B9C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImg);
export default __webpack_public_path__ + "static/media/placeholderImg.a20f557e5bcd2acfc3a22e72b8e97658.svg";
export { ForwardRef as ReactComponent };